import customAxios from "./axiosConfig";

const MolliePaymentService = {
    connectMollie: function (data) {
        var api_url = window.Urls['mollieuser-connect-mollie']();
        return customAxios.post(api_url,data);
    },
    profile: function () {
        var api_url = window.Urls['mollieuser-profile'](window.company_id);
        return customAxios.get(api_url);
    },
    allProfiles: function () {
        var api_url = window.Urls['mollieuser-all-profiles'](window.company_id);
        return customAxios.get(api_url);
    },
    updateProfile: function (data) {
        var api_url = window.Urls['mollieuser-update-profile'](window.company_id);
        return customAxios.post(api_url,data);
    },
    getOnboardingStatus: function () {
        var api_url = window.Urls['mollieuser-onboarding-status'](window.company_id);
        return customAxios.get(api_url);
    },
    getPaymentList: function () {
        var api_url = window.Urls['mollieuser-payment-list'](window.company_id);
        return customAxios.get(api_url);
    },
    createPayment: function (data) {
        var api_url = window.Urls['mollieuser-create-payment'](window.company_id);
        return customAxios.post(api_url,data);
    },
    disconnect: function () {
        var api_url = window.Urls['mollieuser-disconnect'](window.company_id);
        return customAxios.get(api_url);
    },
    getConnectionStatus: function () {
        var api_url = window.Urls['mollieuser-connection-status'](window.company_id);
        return customAxios.get(api_url);
    },
    getPaymentsLeft: function () {
        var api_url = window.Urls['mollieuser-payments-left'](window.company_id);
        return customAxios.get(api_url);
    },
};

export default MolliePaymentService;